import { z } from 'zod';
import { MonthArray } from './common.js';
export const Depot = z.object({
    id: z.number().int(),
    name: z.string().min(1).max(160),
    sub: z.string().max(120).nullable(),
    badge: z.string().min(1).max(2),
    amounts: MonthArray,
    sort_order: z.number().int(),
});
export const CreateDepotRequest = z.object({
    name: z.string().min(1).max(160),
    sub: z.string().max(120).nullable().optional(),
    badge: z.string().min(1).max(2).optional(),
});
export const UpdateDepotRequest = z
    .object({
    name: z.string().min(1).max(160).optional(),
    sub: z.string().max(120).nullable().optional(),
    badge: z.string().min(1).max(2).optional(),
    amounts: MonthArray.optional(),
    sort_order: z.number().int().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
